import { useMutation, UseMutationResult } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

interface SubjectPayload {
  subject: string;
  category: string;
}

export const useAddSubjectMutation = () => {
  const token = localStorage.getItem("W2ST_ADMIN_TOKEN");

  return useMutation(
    (payload: SubjectPayload) =>
      axiosInstance
        .patch("admins/tutors/add-tutor-subject", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    {
      onSuccess: async () => {
        message.success("Subject Created");
        queryClient.invalidateQueries("useGetSubjectsQuery");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message || "Failed... Please try again."
        );
      },
    }
  );
};
